module.exports = __webpack_public_path__ + "img/otkritost.46fe231a.png";